import { render, staticRenderFns } from "./debtDetail.vue?vue&type=template&id=a038aa0c&scoped=true"
import script from "./debtDetail.vue?vue&type=script&lang=js"
export * from "./debtDetail.vue?vue&type=script&lang=js"
import style0 from "./debtDetail.vue?vue&type=style&index=0&id=a038aa0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a038aa0c",
  null
  
)

export default component.exports